module.exports = __webpack_public_path__ + "static/media/hint.e159f0fb.ogg";